import { Injectable } from '@angular/core';
import { CustomNotification } from 'app/utilities/types/notification';
import { BehaviorSubject, delay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationTime = 5000;
  private notifications = new BehaviorSubject<CustomNotification[]>([
    // { id: '1', message: 'This is a successful notification.', type: 'success', timeout: 5 },
    // { id: '2', message: 'This is a warning notification.', type: 'warning', timeout: 5 },
    // { id: '3', message: 'This is an error notification.', type: 'error', timeout: 5 },
    // { id: '4', message: 'This is an info notification.', type: 'info', timeout: 5 },
  ]);
  notifications$ = this.notifications.asObservable();
  constructor() {}

  removeNotification(id: string) {
    const currentNotifications = this.notifications.getValue();
    const updatedNotifications = currentNotifications.filter(
      (notification) => notification.id !== id,
    );
    this.notifications.next(updatedNotifications);
  }

  notify(
    notification: Omit<Omit<CustomNotification, 'id'>, 'timeout'> &
      Partial<Pick<Omit<CustomNotification, 'id'>, 'timeout'>>,
  ) {
    //generate uuid
    const newNotification = {
      timeout: this.notificationTime,
      ...notification,
      id: crypto.randomUUID(),
    };
    this.notifications.next([...this.notifications.getValue(), newNotification]);

    setTimeout(() => this.removeNotification(newNotification.id), newNotification.timeout);
  }
}
